import AuthenticationService from '@/services/coda-qa-user/authentication.service';
import { AuthenticationData } from '@/types/coda-qa-user/auth.types';

export class Authentication {
  private static LOCAL_STORAGE_ACCESS_TOKEN = 'accessToken';
  private static LOCAL_STORAGE_REFRESH_TOKEN = 'refreshToken';

  private static isRefreshingToken = false;

  public static async refreshTokens() {
    if (this.isRefreshingToken) {
      return;
    }

    this.isRefreshingToken = true;

    try {
      const { data: authenticationData } = await AuthenticationService.refreshTokens(
        this.refreshToken
      );
      this.updateTokens(authenticationData);
    } catch (e) {
      this.logout();
      throw e;
    } finally {
      this.isRefreshingToken = false;
    }
  }

  public static async login(username: string, password: string) {
    const { data: authenticationData } = await AuthenticationService.login({
      username,
      password,
    });
    this.updateTokens(authenticationData);
  }

  public static logout() {
    localStorage.removeItem(this.LOCAL_STORAGE_ACCESS_TOKEN);
    localStorage.removeItem(this.LOCAL_STORAGE_REFRESH_TOKEN);
  }

  public static updateTokens({ accessToken, refreshToken }: AuthenticationData) {
    this.accessToken = accessToken;
    this.refreshToken = refreshToken;
  }
  public static set accessToken(token: string) {
    localStorage.setItem(this.LOCAL_STORAGE_ACCESS_TOKEN, token);
  }

  public static get accessToken() {
    return localStorage.getItem(this.LOCAL_STORAGE_ACCESS_TOKEN) || '';
  }

  public static set refreshToken(token: string) {
    localStorage.setItem(this.LOCAL_STORAGE_REFRESH_TOKEN, token);
  }

  public static get refreshToken() {
    return localStorage.getItem(this.LOCAL_STORAGE_REFRESH_TOKEN) || '';
  }
}
